// Textes de la page des événements
export const EVENTS_TEXTS = {
  title: 'Événements',
  status: 'Statut',
  confirmed: 'Confirmé',
  alertName: 'Alerte',
  locationName: 'Emplacement',
  sensorName: 'Capteur',
  triggeredAt: 'Déclenché à',
  resolvedAt: 'Résolu à',
  confirmedAt: 'Confirmé à',
  loading: 'Chargement des événements...',
  errorLoading: 'Erreur lors du chargement des événements',
  noEvents: 'Aucun événement trouvé',
  selectFilters: 'Sélectionner des filtres',
  selectOrgAndLocationMessage: 'Veuillez sélectionner des filtres pour voir les événements',
  selectLocationMessage: 'Veuillez sélectionner un emplacement pour voir les événements',
  selectOrgAndLocationDescription: 'Utilisez le panneau de filtres ci-dessus pour sélectionner une organisation et un emplacement.',
  selectLocationDescription: 'Utilisez le panneau de filtres ci-dessus pour sélectionner un emplacement pour voir ses événements.',
  filterByOrganization: 'Filtrer par organisation',
  filterByStatus: 'Filtrer par statut',
  selectOrganization: 'Sélectionner une organisation',
  selectLocation: 'Sélectionner un emplacement',
  allOrganizations: 'Toutes les organisations',
  allLocations: 'Tous les emplacements',
  statusTriggered: 'Déclenché',
  statusPending: 'En attente',
  statusResolved: 'Résolu',
  statusCanceled: 'Annulé',
  statusUnknown: 'Inconnu',
  yes: 'Oui',
  no: 'Non',
  never: 'Jamais',
  dateFrom: 'De',
  dateTo: 'À',
  lastUpdated: 'Dernière mise à jour :',
  refresh: 'Rafraîchir',
  // Textes du dialogue de document JSON de l'événement
  documentDialog: {
    title: 'Document JSON de l\'événement',
    eventLabel: 'Événement :',
    description: 'Visualisation du document complet de l\'événement en format JSON'
  }
} as const;